<div fxLayout="column" fxLayoutGap="20px">
  <div fxLayoutAlign="space-between center">
    <h1>Notas da Inscrição - Recurso #{{ recursoId }}</h1>
    <button mat-raised-button color="primary" (click)="voltar()">
      <mat-icon>arrow_back</mat-icon> Voltar
    </button>
  </div>

  <mat-spinner *ngIf="loading"></mat-spinner>

  <div *ngIf="!loading && resumoNotas">
    <div fxLayout="row" fxLayoutGap="20px">
      <mat-card fxFlex="50">
        <mat-card-header>
          <mat-card-title>Dados do Candidato</mat-card-title>
          <span class="spacer"></span>
          <button mat-icon-button color="primary" (click)="visualizarDocumentosComplementares()" matTooltip="Visualizar documentos complementares">
            <mat-icon>folder</mat-icon>
          </button>
        </mat-card-header>
        <mat-card-content>
          <div fxLayout="column" fxLayoutGap="10px">
            <div><strong>Nome:</strong> {{ resumoNotas.nomeSocial || resumoNotas.nome }}</div>
            <div *ngIf="resumoNotas.nomeSocial"><strong>Nome Social:</strong> {{ resumoNotas.nomeSocial }}</div>
            <div><strong>Data de Nascimento:</strong> {{ resumoNotas.dataNascimento | date: 'dd/MM/yyyy' }}</div>
            <div><strong>Média Final:</strong> {{ resumoNotas.mediaFinal }}</div>
            <div><strong>Conceito:</strong> {{ resumoNotas.conceito }}</div>
            <div *ngIf="resumoNotas.justificativa"><strong>Justificativa:</strong> {{ resumoNotas.justificativa }}</div>
          </div>
        </mat-card-content>
        <mat-card-actions *ngIf="resumoNotas.idArquivoProva && resumoNotas.arquivoProva" align="end">
          <button mat-raised-button color="primary" (click)="visualizarProvaEscrita()">
            <mat-icon>visibility</mat-icon> Visualizar Prova Escrita
          </button>
        </mat-card-actions>
      </mat-card>

      <mat-card *ngIf="resumoNotas.textoRecurso" fxFlex="50">
        <mat-card-header>
          <mat-card-title>Justificativa do Recurso</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p class="texto-justificativa">{{ resumoNotas.textoRecurso }}</p>
        </mat-card-content>
        <mat-card-actions *ngIf="resumoNotas.anexoRecurso" align="end">
          <button mat-raised-button color="primary" (click)="visualizarAnexo()">
            <mat-icon>visibility</mat-icon> Visualizar Anexo
          </button>
        </mat-card-actions>
      </mat-card>
    </div>

    <mat-card *ngIf="resumoNotas.notasPorExaminador">
      <mat-card-header>
        <mat-card-title>Análise do Recurso</mat-card-title>
      </mat-card-header>
      <mat-card-content>

        <div *ngIf="isRecursoFase2PendenteAnalise" class="parecer-comissao-section" style="margin-bottom: 24px;">
          <mat-card class="card-warning" style="margin-bottom: 16px;">
            <span>⚠️ Este recurso aguarda análise. Anexe o parecer em PDF e defira ou indefira o recurso.</span>
          </mat-card>

          <div style="margin-bottom: 16px;">
            <input #parecerAnexoInputF2 type="file" accept="application/pdf" (change)="onFileSelected($event)" style="display: none;" />
            <mat-form-field appearance="outline" style="width: 100%; cursor: pointer;">
              <mat-label>Anexo do parecer (PDF) *</mat-label>
              <input matInput readonly [value]="arquivoParecer?.name || ''" placeholder="Selecione um arquivo..." style="cursor: pointer;" (click)="parecerAnexoInputF2.click()" />
              <mat-icon matSuffix style="cursor: pointer;" (click)="parecerAnexoInputF2.click()">attach_file</mat-icon>
            </mat-form-field>
          </div>

          <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center">
            <button mat-raised-button color="primary" (click)="deferirRecurso()" [disabled]="!arquivoParecer" data-faro-user-action-name="deferir-recurso-fase2">
              <mat-icon>check_circle</mat-icon> Deferir
            </button>
            <button mat-raised-button color="warn" (click)="indeferirRecurso()" [disabled]="!arquivoParecer" data-faro-user-action-name="indeferir-recurso-fase2">
              <mat-icon>cancel</mat-icon> Indeferir
            </button>
          </div>
        </div>

        <div *ngIf="isRecursoFase1PendenteAnalise" class="parecer-comissao-section" style="margin-bottom: 24px;">
          <mat-card class="card-warning" style="margin-bottom: 16px;">
            <span>⚠️ Este recurso aguarda análise. Anexe o parecer em PDF e defira para alterar as notas, ou indefira.</span>
          </mat-card>

          <div style="margin-bottom: 16px;">
            <input #parecerAnexoInput type="file" accept="application/pdf" (change)="onFileSelected($event)" style="display: none;" />
            <mat-form-field appearance="outline" style="width: 100%; cursor: pointer;">
              <mat-label>Anexo do parecer (PDF) *</mat-label>
              <input matInput readonly [value]="arquivoParecer?.name || ''" placeholder="Selecione um arquivo..." style="cursor: pointer;" (click)="parecerAnexoInput.click()" />
              <mat-icon matSuffix style="cursor: pointer;" (click)="parecerAnexoInput.click()">attach_file</mat-icon>
            </mat-form-field>
          </div>

          <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center">
            <button mat-raised-button color="primary" (click)="deferirRecurso()" [disabled]="!arquivoParecer" data-faro-user-action-name="deferir-recurso">
              <mat-icon>check_circle</mat-icon> Deferir
            </button>
            <button mat-raised-button color="warn" (click)="indeferirRecurso()" [disabled]="!arquivoParecer" data-faro-user-action-name="indeferir-recurso">
              <mat-icon>cancel</mat-icon> Indeferir
            </button>
          </div>
        </div>

        <div *ngIf="!isRecursoFase1PendenteAnalise && resumoNotas.parecerRecurso && resumoNotas.parecerRecurso !== 'Em Análise'" class="parecer-resultado-section" style="margin-bottom: 24px;">
          <mat-card [ngClass]="{'card-success': resumoNotas.parecerRecurso === 'Deferido', 'card-danger': resumoNotas.parecerRecurso === 'Indeferido'}">
            <mat-card-header>
              <mat-card-title>Parecer da Comissão</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                <mat-icon *ngIf="resumoNotas.parecerRecurso === 'Deferido'" color="primary">check_circle</mat-icon>
                <mat-icon *ngIf="resumoNotas.parecerRecurso === 'Indeferido'" color="warn">cancel</mat-icon>
                <span><strong>Resultado:</strong> {{ resumoNotas.parecerRecurso }}</span>
              </div>
            </mat-card-content>
          </mat-card>
        </div>

        <div *ngIf="!isRecursoFase1PendenteAnalise && !resumoNotas.recursoFase2">
        <table mat-table [dataSource]="getExaminadores()">
          <ng-container matColumnDef="examinador">
            <th mat-header-cell *matHeaderCellDef>Examinador</th>
            <td mat-cell *matCellDef="let examinador" [matTooltip]="getMatricula(examinador)">{{ examinador.nome }}</td>
          </ng-container>

          <ng-container *ngFor="let prova of getProvas()" [matColumnDef]="prova">
            <th mat-header-cell *matHeaderCellDef>{{ prova }}</th>
            <td mat-cell *matCellDef="let examinador">
              <input
                class="score-input"
                type="number"
                min="0"
                max="10"
                step="0.01"
                [(ngModel)]="examinador.notas[prova]"
                (blur)="onNotaChange(examinador, prova, $event)"
                (keydown.enter)="onNotaChange(examinador, prova, $event)"
              />
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="getDisplayedColumns()"></tr>
          <tr mat-row *matRowDef="let row; columns: getDisplayedColumns()"></tr>
        </table>
        <mat-card class="card-warning" style="margin-top: 16px; margin-bottom: 16px;">
          <span>ℹ️ Conforme definição da SG e PG, nenhum candidato é prejudicado (desclassificado) após a retificação de nota de outro candidato.</span>
        </mat-card>
        <div class="text-center-mt-20">
          <button mat-raised-button color="primary" (click)="salvarNotas()">
            <mat-icon>save</mat-icon> Salvar Notas
          </button>
        </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
